module.exports = "<table-header\n    items=\"$ctrl.headerColumns\"\n    on-sort=\"$ctrl.sort(sortField, sortDirection)\"\n></table-header>";


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/components/table-component/table-component.html
// module id = 1375
// module chunks = 0